
<template>
    <div class="h-screen flex w-full bg-img">
        
        
    </div>
    
</template>

<script>
export default {
  data () {
    return {
      value1: '',
    }
  },
  created() {
    this.$vs.loading()
      const payload = {
            userId: this.$route.query.userId,
            code: this.$route.query.code,
          };
          
       this.$store
            .dispatch("auth/confirmAccount", payload)
            .then(() => {
              this.$vs.loading.close()
              this.$store.dispatch('hrms/autoUpdatePassword', payload.userId)
                .then(() => {
                  this.$router.push('/pages/account-success')
                })
              
            })
            .catch(() => {
              this.$vs.loading.close()
              this.$router.push('/pages/account-error')
            });
  }
}
</script>
